import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitEnquiry = async (payload) => {
  const { data } = await axios.post(`${API}/enquiries`, payload);
  return data;
};
